<template>
  <el-drawer
    :visible.sync="isVisible"
    size="94%"
    :append-to-body="false"
    :modal-append-to-body="false"
    :show-close="false"
    :modal="false"
    :wrapper-closable="false"
    :close-on-press-escape="false"
    @closed="handleClose"
  >
    <template #title>
      <div class="reschedule-drawer__title-bar">
        <el-button type="text" icon="el-icon-close" class="reschedule-drawer__close" @click="isVisible = false" />
      </div>
    </template>
    <section class="drawer-layout Jost">
      <div class="drawer-layout__scroll">
        <div class="drawer-layout__header">
          <div class="drawer-layout__header-row">
            <div class="drawer-layout__header-title">修改日期</div>
            <div class="drawer-layout__header-order">訂單編號：{{ orderDisplayId || '-' }}</div>
          </div>
        </div>

        <div class="drawer-layout__content">
          <HotelRescheduleScheduler
            v-if="isVisible"
            ref="scheduler"
            :product-id="productId"
            :container-id="containerId"
            :initial-bookings="initialBookings"
            :order-guests="orderGuests"
            :room-title="roomTitle"
            @confirm="onSchedulerConfirm"
            @selection-change="onSelectionChange"
          />
        </div>
      </div>

      <HotelRescheduleBottomBar
        v-if="selectionState.active"
        :selected-stay-range="selectionState.selectedStayRange"
        :order-pet-count="selectionState.orderPetCount"
        :disabled="selectionState.selectedRoomsList.length === 0"
        @confirm="onBottomBarConfirm"
      />
    </section>
  </el-drawer>
</template>

<script>
import HotelRescheduleScheduler from './HotelRescheduleScheduler.vue'
import HotelRescheduleBottomBar from './HotelRescheduleBottomBar.vue'

export default {
  name: 'OrderRescheduleDrawerPartial',
  components: {
    HotelRescheduleScheduler,
    HotelRescheduleBottomBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    orderDisplayId: {
      type: String,
      default: '',
    },
    productId: {
      type: [String, Number],
      default: '',
    },
    containerId: {
      type: String,
      default: '',
    },
    initialBookings: {
      type: Array,
      default: () => [],
    },
    orderGuests: {
      type: Array,
      default: () => [],
    },
    roomTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectionState: {
        active: false,
        selectedRoomsList: [],
        selectedStayRange: '',
        orderPetCount: 0,
      },
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleClose() {
      this.$refs.scheduler?.reset()
      this.selectionState = {
        active: false,
        selectedRoomsList: [],
        selectedStayRange: '',
        orderPetCount: 0,
      }
      this.$emit('close')
    },
    onSelectionChange(state) {
      this.selectionState = {
        active: false,
        selectedRoomsList: [],
        selectedStayRange: '',
        orderPetCount: 0,
        ...state,
      }
    },
    onBottomBarConfirm() {
      this.$refs.scheduler?.confirmSelection()
    },
    onSchedulerConfirm(selectedRooms) {
      this.$emit('confirm', selectedRooms)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer__header {
  position: fixed;
  top: 0px;
  left: 75px;
  padding: 0px;
  margin-bottom: 0;
}

.reschedule-drawer__title-bar {
  display: flex;
  align-items: center;
}

.reschedule-drawer__close {
  font-size: 32px;
  font-weight: 500;
  padding: 0;
}

::v-deep .el-drawer__close-btn {
  font-size: 2.5rem;
}

::v-deep .el-drawer__body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100vh - 60px);
}

.drawer-layout {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  position: relative;
  padding: 0px 12px;
  overflow: hidden;

  &__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 0px 18px 0px 48px;
    font-size: 16px;
    line-height: 1.8;

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: #f0f0f0;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #999;
      border-radius: 4px;
      border: 2px solid #f0f0f0;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: #666;
    }
  }

  &__header {
    position: sticky;
    top: 0;
    padding: 8px 0;
    z-index: 10;
    background-color: #f9f9fb;
    border-bottom: 1px solid #e6e6e6;
    font-size: 20px;
    font-weight: 700;
    line-height: 2.2;

    &-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-title {
      color: #000000;
      font-size: 20px;
      font-weight: 700;
    }

    &-order {
      color: #000000;
      font-size: 16px;
      font-weight: 400;
    }
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    margin: 20px 0 0;
    font-size: 14px;
  }
}
</style>
